module.exports = __webpack_public_path__ + "static/media/Swimming Pool Stairs.3deb730d.svg";